import { render, staticRenderFns } from "./Cxv.vue?vue&type=template&id=5c3f9f10&scoped=true"
import script from "./Cxv.vue?vue&type=script&lang=js"
export * from "./Cxv.vue?vue&type=script&lang=js"
import style0 from "./Cxv.vue?vue&type=style&index=0&id=5c3f9f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f9f10",
  null
  
)

export default component.exports